import oAxiosInstance from "config/Axios";

export const apiCallGetAllDocumentTypesPartners = () => {
  return oAxiosInstance.get("socios/tiposdocsidentidad");
};
